"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbsReview = exports.THUMBS_UP_DEFAULT_VALUE = exports.THUMBS_DOWN_DEFAULT_VALUE = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Layout = require("../../atoms/Layout");

var _ThumbsIconButton = require("../../atoms/ThumbsIconButton");

var THUMBS_DOWN_DEFAULT_VALUE = 'no';
exports.THUMBS_DOWN_DEFAULT_VALUE = THUMBS_DOWN_DEFAULT_VALUE;
var THUMBS_UP_DEFAULT_VALUE = 'yes';
exports.THUMBS_UP_DEFAULT_VALUE = THUMBS_UP_DEFAULT_VALUE;

var ThumbsReview = function ThumbsReview(_ref) {
  var onClick = _ref.onClick,
      thumbsDownValue = _ref.thumbsDownValue,
      thumbsUpValue = _ref.thumbsUpValue;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedReview = _useState2[0],
      setSelectedReview = _useState2[1];

  var onThumbsIconClick = function onThumbsIconClick(value) {
    setSelectedReview(value);
    onClick(value);
  };

  var getThumbsIconButton = function getThumbsIconButton(_ref2) {
    var reviewValue = _ref2.reviewValue,
        icon = _ref2.icon;
    return _react.default.createElement(_Layout.GridItem, {
      gridRow: "1"
    }, _react.default.createElement(_ThumbsIconButton.ThumbsIconButton, {
      selected: selectedReview === reviewValue,
      onClick: function onClick() {
        return onThumbsIconClick(reviewValue);
      },
      icon: icon
    }));
  };

  return _react.default.createElement(_Layout.Grid, {
    gridRowGap: [3, 3, 3],
    gridTemplateColumns: "repeat(2, minmax(60px, 1fr))",
    style: {
      justifyItems: 'center'
    }
  }, getThumbsIconButton({
    reviewValue: thumbsUpValue,
    icon: _ThumbsIconButton.THUMBS_UP_ICON
  }), getThumbsIconButton({
    reviewValue: thumbsDownValue,
    icon: _ThumbsIconButton.THUMBS_DOWN_ICON
  }));
};

exports.ThumbsReview = ThumbsReview;
ThumbsReview.defaultProps = {
  thumbsDownValue: THUMBS_DOWN_DEFAULT_VALUE,
  thumbsUpValue: THUMBS_UP_DEFAULT_VALUE
};